import { render } from "./FivthBar.vue?vue&type=template&id=dd4a0ca2&scoped=true"
import script from "./FivthBar.vue?vue&type=script&lang=js"
export * from "./FivthBar.vue?vue&type=script&lang=js"

import "./FivthBar.vue?vue&type=style&index=0&id=dd4a0ca2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd4a0ca2"]])

export default __exports__